/** Running from local webserver. */
export const isRunningLocal =
  globalThis.location.hostname === 'local.dev.obsec.us';

/** Running in Storybook local or deployed to GitLab Pages. */
export const isRunningStorybook =
  globalThis.location.port === '6006' ||
  globalThis.location.hostname === 'obsec1.gitlab.io' ||
  globalThis.location.hostname === 'obi-ui.frontend.pages.obsec.io';

/** Jest unit test environment (yarn test). */
export const isTestEnv = process.env.NODE_ENV === 'test';
